import { useCallback } from 'react'
import { useLocalStorage } from 'react-use'

import { useUpdateOrganizationSettings } from '@modules-deprecated/app/organization/hooks/useUpdateOrganizationSettings'
import { useUserOrganization } from '@modules-deprecated/app/organization/userOrganizationContext'
import { useUserOrganizationSettings } from '@modules-deprecated/app/organization/userOrganizationSettingsContext'

import { LocalStorageKeys } from '../../../enums/localStorageKeys'
import { OnboardingFinalizedStateType, OnboardingSetupStep } from '../types'
import { isOnboardingFinalized } from '../utils/isOnboardingFinalized'

export const useOnboardingStepPersistence = () => {
  const { organization } = useUserOrganization()
  const { isFetched, organizationSettings } = useUserOrganizationSettings()
  const [, setIsOnboardingFinalized, removeIsOnboardingFinalized] = useLocalStorage(
    `${LocalStorageKeys.OnboardingFinalized}-${organization?.id ?? ''}`,
  )
  const { update } = useUpdateOrganizationSettings({
    shouldRefetch: false,
  })

  const onboardingCurrentStep = organizationSettings?.onboardingCurrentStep
  const onboardingPlatform = organizationSettings?.onboardingPlatform

  const updateCurrentStep = useCallback(
    (step: OnboardingSetupStep | OnboardingFinalizedStateType) => {
      if (!organization?.id) {
        return
      }

      update(
        { key: 'onboardingCurrentStep', organizationId: organization.id, value: step },
        {
          onError(_error, variables) {
            if (isOnboardingFinalized(variables?.value as OnboardingSetupStep | OnboardingFinalizedStateType)) {
              removeIsOnboardingFinalized()
            }
          },
        },
      )

      // Flag the onboarding as finalized in localStorage when the user completes or skips it
      if (isOnboardingFinalized(step)) {
        setIsOnboardingFinalized(true)
      }
    },
    [organization?.id, removeIsOnboardingFinalized, setIsOnboardingFinalized, update],
  )

  return { isFetched, onboardingCurrentStep, onboardingPlatform, updateCurrentStep }
}
